import log from '@vcclive/log';
import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { SagaBuilder } from '../interfaces/redux';

const debug = log.getDebug('saga');
const debugDispatch = log.getDebug('saga:dispatch');

export function createSagaMiddleware<S>(saga: SagaBuilder<S>): Middleware {
    // @ts-ignore
    return sagaMiddleware.bind(null, saga);
}

function sagaMiddleware<S>(saga: SagaBuilder<S>, api: MiddlewareAPI<Dispatch, S>) {
    let dispatching = false;
    const actionQueue: Action[] = [];

    debug('init sagaMap');
    const sagaMap = saga({
        dispatch<A extends Action>(action: A) {
            if (dispatching) {
                log.debug(`queue action: ${action.type}`);
                actionQueue.push(action);
            } else {
                // debug('dispatch action: ' + action.type);
                api.dispatch(action);
            }
            return action;
        },
        getState: api.getState,
    });

    return (next: Dispatch<Action>) => (action: Action) => {
        debugDispatch(action);
        // noinspection JSUnusedAssignment
        dispatching = true;
        const prevState = api.getState();
        const result = next(action);
        try {
            if (sagaMap && sagaMap[action.type]) {
                sagaMap[action.type](action, prevState);
            }
        } catch (error) {
            log.debug('saga error:', action);
            log.error(error);
        }
        dispatching = false;
        const nextAction = actionQueue.shift();
        if (nextAction) {
            debug(`fire next action: ${nextAction.type}`);
            setTimeout(() => {
                api.dispatch(nextAction);
            }, 0);
        }
        return result;
    };
}
